import AbstractRequestTask from "../AbstractRequestTask";
import getAppConfig from "../../../config/appConfig";
import settings from "../../../devices/all/settings";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class CheckSinglePlayTask extends AbstractRequestTask {
  constructor(cm_access_token) {
    super();
    this.service = "/middleware/player/checksingleplay";
    this.config = getAppConfig();
    this.cm_access_token = cm_access_token;
  }

  getUrl() {
    return `${this.config.end_point_music}${this.service}`;
  }

  getParams() {
    const params = super.getParams(this.config);
    const { tenant_code } = settings;
    params.tenant_code = tenant_code;
    params.version = '1.0.0';
    params.cm_access_token = this.cm_access_token;

    return { ...params, ...this._params };
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
}

export default CheckSinglePlayTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/music/CheckSinglePlayTask.js